<template>
  <div>
    <EkitabuSchoolSelect
      v-model="schoolId"
      class="mb-3"
    />
    <ekitabu-text-input
      id="autocomplete"
      v-model="studentName"
      class="mb-3"
      :label="$t('checkout.delivery.studentName')"
      :placeholder="$t('checkout.delivery.studentName')"
      required
      rules="required|min:3"
    />
    <ekitabu-text-input
      id="autocomplete"
      v-model="studentClass"
      class="mb-3"
      :label="$t('checkout.delivery.studentGrade')"
      :placeholder="$t('checkout.delivery.studentGrade')"
      required
      rules="required|min:3"
    />
  </div>
</template>

<script>
import EkitabuSchoolSelect from "@/components/inputs/EkitabuSchoolSelect.vue";
import EkitabuTextInput from "@/components/EkitabuTextInput";

export default {
  name: "DeliverToSchool",
  components: {
    EkitabuSchoolSelect,
    EkitabuTextInput,
  },
  data() {
    return {
      schoolId: null,
      studentName: null,
      studentClass: null,
    };
  },
  watch: {
    schoolId() {
      this.updateSchoolData();
    },
    studentName() {
      this.updateSchoolData();
    },
    studentClass() {
      this.updateSchoolData();
    },
  },
  methods: {
    updateSchoolData() {
      this.$emit("updateSchoolData", {
        schoolId: this.schoolId,
        studentName: this.studentName,
        studentClass: this.studentClass,
      });
    },
  }
}
</script>